import { InventoryLocation } from './inventory-location';

export class Inventory {
    isTracked: boolean;
    trackedIn: number;
    locations: Array<InventoryLocation>;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/inventory.ts